<app-modal-header
  [title]="title"
  (closeModal)="closeModal()"
></app-modal-header>

<!-- Loading -->
<div *ngIf="loading" class="p-4 text-center">
  <p>Loading sensor data...</p>
</div>

<!-- No Data -->
<div *ngIf="!loading && tableData.length === 0" class="p-4 text-center text-gray-500">
  No sensor data available.
</div>

<!-- Table (Only show when data exists) -->
<app-paginated-data-table
  *ngIf="!loading && tableData.length > 0"
  [tableConfigurations]="tableConfiguration"
  [tableList]="tableData"
  [mapFunction]="mapFunction"
  [loading]="tableConfiguration.doneLoading"
>
</app-paginated-data-table>